import type { ExcelCellValue, ExcelSheetSpec, ResolvedExcelColumn, ResolvedSheet } from "./types";

const DEFAULT_COLUMN_WIDTH = 40;
const DEFAULT_FREEZE = { xSplit: 1, ySplit: 2 };
const DEFAULT_LABEL_COLUMN_COUNT = 1;

export default function defineSheet<TRow>(spec: ExcelSheetSpec<TRow>): ResolvedSheet {
    const columns: ResolvedExcelColumn[] = spec.columns.map(column => ({
        key: column.key,
        header: column.header,
        width: column.width ?? DEFAULT_COLUMN_WIDTH,
        role: column.role ?? "value"
    }));

    return {
        name: spec.name,
        title: spec.title,
        subtitle: spec.subtitle,
        columns,
        freeze: spec.freeze ?? DEFAULT_FREEZE,
        labelColumnCount: spec.labelColumnCount ?? DEFAULT_LABEL_COLUMN_COUNT,
        onRendered: spec.onRendered,
        forEachRow(visit: (cells: ExcelCellValue[]) => void) {
            spec.rows.forEach(row => visit(spec.columns.map(column => column.value(row))));
        }
    };
}
